// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1mE5w","upload":"Small_upload__1Kuk8","imageWrap":"Small_imageWrap__1ceTy","removeBtn":"Small_removeBtn__zbuik"};